import { sortAlphabeticallyByKey } from '@fortem-monorepo/js-utilities'

export const INDEX_TYPES = [
  'Equity',
  'FX',
  'Rate',
  'CDS',
  'Commodity',
  'Bond',
  'Inflation',
] as const

export type IndexType = (typeof INDEX_TYPES)[number]

export const INDEX_TYPE_LABELS: Record<IndexType, string> = {
  Equity: 'Equity',
  FX: 'FX',
  Rate: 'Rate',
  CDS: 'CDS',
  Commodity: 'Commodity',
  Bond: 'Bond',
  Inflation: 'Inflation',
}

export const INDEX_TYPE_OPTIONS = sortAlphabeticallyByKey(
  INDEX_TYPES.map((t) => ({
    label: INDEX_TYPE_LABELS[t],
    value: t,
  })),
  'label',
)
